"use client";
import React from "react";
import VariantPetStepHero from "./VariantPetStepHero";
import HowSpotWorks from "./HowSpotWorks";

export default function SimplifiReassurance() {
    return (
        <div className="lg:mt-[-160px]">
            <VariantPetStepHero variant="whySpot" simplifiVariant="reassurance" bottomSlot={<HowSpotWorks />} />
        </div>
    );
}
